const PASSWORD = {
  MINLENGTH: 8,
  MAXLENGTH: 72,
};

export default PASSWORD;
